/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Compare_Event_Groups_Alignment_LabelInputs */

const en_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alignment ${i?.index}`)
};

const fr_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alignement ${i?.index}`)
};

const de_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ausrichtung ${i?.index}`)
};

const it_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Allineamento ${i?.index}`)
};

const ru_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выравнивание ${i?.index}`)
};

const es_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alineación ${i?.index}`)
};

const zh_cn2_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`对齐方式 ${i?.index}`)
};

const ja_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アライメント ${i?.index}`)
};

const hi_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`संरेखण ${i?.index}`)
};

const pt_pt2_compare_event_groups_alignment_label = /** @type {(inputs: Compare_Event_Groups_Alignment_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alinhamento ${i?.index}`)
};

/**
* | output |
* | --- |
* | "Alignment {index}" |
*
* @param {Compare_Event_Groups_Alignment_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_alignment_label = /** @type {((inputs: Compare_Event_Groups_Alignment_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Alignment_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_alignment_label(inputs)
	if (locale === "de") return de_compare_event_groups_alignment_label(inputs)
	if (locale === "it") return it_compare_event_groups_alignment_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_alignment_label(inputs)
	if (locale === "es") return es_compare_event_groups_alignment_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_alignment_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_alignment_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_alignment_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_alignment_label(inputs)
	return en_compare_event_groups_alignment_label(inputs)
});